import { HitDto } from "../types/TargetScannedDataDTOs";


export const calculateMaxSpread = (coordinatesOfHitsRelativeToCenter: HitDto[]): number => {
    let maxSpread = 0;

    //complexity can be reduced with Convex hull algorithm
    for (let i: number = 0; i < coordinatesOfHitsRelativeToCenter.length - 1; i++) {
        for (let j: number = i + 1; j < coordinatesOfHitsRelativeToCenter.length; j++) {
            const spread: number = calculateDistance(coordinatesOfHitsRelativeToCenter[i], coordinatesOfHitsRelativeToCenter[j]);

            if (spread > maxSpread) {
                maxSpread = spread;
            }
        }
    }

    return maxSpread;
};

export const calculateMeanRadius = (coordinatesOfHitsRelativeToCenter: HitDto[]): number => {
    const groupCenter: HitDto = calculateGroupCenterPosition(coordinatesOfHitsRelativeToCenter);

    const hitsRadiusesSum: number = coordinatesOfHitsRelativeToCenter
        .map(hit => calculateDistance(hit, groupCenter))
        .reduce((a, b) => a + b, 0)

    return hitsRadiusesSum / coordinatesOfHitsRelativeToCenter.length;
};

export const calculateGroupCenterPosition = (coordinatesOfHitsRelativeToCenter: HitDto[]): HitDto => {
    let xCoordinatesSum: number = 0;
    let yCoordinatesSum: number = 0;

    coordinatesOfHitsRelativeToCenter.forEach(hit => {
        xCoordinatesSum += hit.x;
        yCoordinatesSum += hit.y;
    });

    return {
        x: xCoordinatesSum / coordinatesOfHitsRelativeToCenter.length,
        y: yCoordinatesSum / coordinatesOfHitsRelativeToCenter.length
    }
};

export const calculateGroupWidth = (coordinatesOfHitsRelativeToCenter: HitDto[]): number => {
    if (coordinatesOfHitsRelativeToCenter.length == 1) {
        return 0;
    }

    return calculateMaxCoordinateDifference(coordinatesOfHitsRelativeToCenter.map(hit => hit.x));
};

export const calculateGroupHeight = (coordinatesOfHitsRelativeToCenter: HitDto[]): number => {
    if (coordinatesOfHitsRelativeToCenter.length == 1) {
        return 0;
    }

    return calculateMaxCoordinateDifference(coordinatesOfHitsRelativeToCenter.map(hit => hit.y));
};

export const calculateDistance = (a: HitDto, b: HitDto): number => {
    return Math.sqrt(((a.x - b.x) * (a.x - b.x)) + ((a.y - b.y) * (a.y - b.y)));
};

const calculateMaxCoordinateDifference = (coordinates: number[]): number => {
    let min: number = coordinates[0];
    let max: number = min;

    coordinates.forEach(coordinate => {
        if (coordinate < min) {
            min = coordinate;
        } else if (coordinate > max) {
            max = coordinate;
        }
    });

    return Math.abs(max - min);
};

const calculateRadius = (x: number, y: number): number => {
    return Math.sqrt(x * x + y * y);
}